import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  authLogin as actionAuthLogin,
  getAuthInvite as actionGetAuthInvite,
  setSignUpType as actionSetSignUpType,
  setSignUpRoute as actionSetSignUpRoute,
  authSignUpComplete as actionAuthSignUpComplete,
  showNetworkAlert as actionShowNetworkError,
} from '../../redux/auth/actions';
import {
  selectSignUpType,
  selectSignUpInvite,
  selectSignUpProperty,
  selectSignUpUser,
  selectSignUpRoute,
  selectAuthenticated,
  selectNetworkError,
} from '../../redux/auth/selectors';

import { withRouter, Route, Redirect, Switch } from 'react-router-dom';

import { get, debounce, delay } from 'lodash';

// import constants from '../../constants';
import routes from '../../constants/routes';
import {
  configs,
  SELECT,
  INFO,
  CONFIRM,
  HOUSEHOLD_SELECT,
  HOUSEHOLD_REQUEST,
  INSTRUCTIONS,
  BUSINESS_SELECT,
  USER_PHOTO,
  PROPERTY_RETRY,
  TYPE_CONTACT_INVITE,
  TYPE_HOUSEHOLD_INVITE,
  TYPE_PROJECT_INVITE,
  PROPERTY_PHOTO,
  PROPERTY_SELECT,
  OUTREACH,
  TYPE_OUTREACH,
  SIGNIN,
  TYPE_GENERIC_BUSINESS,
  INVALID_INVITATION,
  HOUSEHOLD_CONFIRM,
  TYPE_GENERIC_INVITE,
  TYPE_HOMEOWNER_REFERRAL_INVITE,
  TYPE_DOOR_KNOCKING,
} from './config';
import { BUSINESS, USER, FRIEND, HOUSEHOLD } from '../../constants/QMTypes';
import { ngRedirect } from './util';
import constants from '../../constants';

import styles from './styles.scss';

import InfoForm from './screens/InfoForm';
import InfoFormBusiness from './screens/InfoFormBusiness';
import Confirm from './screens/Confirm';
import HouseholdSelect from './screens/HouseholdSelect';
import HouseholdRequest from './screens/HouseholdRequest';
import Instructions from './screens/instructions/Instructions';
import PropertyPhoto from './screens/PropertyPhoto';
import UserPhoto from './screens/UserPhoto';
import Select from './screens/Select';
import PropertyRetry from './screens/PropertyRetry';
import PropertySelect from './screens/PropertySelect/PropertySelect';
import SignIn from './screens/SignIn';

import SignUpBanner from './components/SignUpBanner';
import Loader from '../../components/Loader';
import SignupContainer from './components/SignUpContainer';
import RedirectHelper from './components/RedirectHelper';
import { API_STATUS } from '../../constants/status';
import ExpiredInvitation from './screens/ExpiredInvitation';
import NetworkErrorModal from '../../components/NetworkErrorModal';
import TOSModal from './components/TOSModal';

class SignUpRouter extends Component {
  static propTypes = {
    location: PropTypes.shape({
      state: PropTypes.shape({
        params: PropTypes.shape({
          id: PropTypes.number,
          token: PropTypes.string,
        }),
      }),
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    history: PropTypes.shape({
      replace: PropTypes.func.isRequired,
    }).isRequired,

    authLogin: PropTypes.func.isRequired,
    authSignUpComplete: PropTypes.func.isRequired,
    getAuthInvite: PropTypes.func.isRequired,

    inviteData: PropTypes.object,
    userData: PropTypes.object,
    propertyData: PropTypes.object,

    authenticated: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,

    type: PropTypes.string.isRequired,
    route: PropTypes.string.isRequired,
    setSignUpType: PropTypes.func.isRequired,
    setSignUpRoute: PropTypes.func.isRequired,

    networkErrorData: PropTypes.shape({
      showNetworkError: PropTypes.bool.isRequired,
      networkErrorMessage: PropTypes.string.isRequired,
    }).isRequired,
  };

  static defaultProps = {
    inviteData: null,
    userData: null,
    propertyData: null,
  };

  constructor(props) {
    super(props);

    const { location } = props;

    const { id, token } = get(location, 'state.match.params', {});

    this.state = {
      id,
      token,
      loading: id && token,
      error: null,
      TOSModalOpen: false,
    };

    this.navigateNext = debounce(this.navigateNextOriginal, 250, {
      leading: true,
      trailing: false,
    });
  }

  componentDidMount() {
    this.getInitialData();
  }

  componentDidUpdate(prevProps) {
    const { location, setSignUpRoute } = this.props;
    if (prevProps.location.pathname !== location.pathname) {
      setSignUpRoute(location.pathname);
    }
  }

  getInitialData = () => {
    const { getAuthInvite, location, setSignUpType, history } = this.props;
    const { id, token } = this.state;
    if (id && token) {
      this.setState({
        loading: true,
      });

      const queryParams = get(location, 'state.location.search');

      getAuthInvite(id, token, get(location, 'state.fresh', false), queryParams)
        .then(this.setInviteType)
        .catch(error => {
          history.replace(INVALID_INVITATION);
          this.setState({
            loading: false,
            error,
          });
        });
    } else if (location.pathname === OUTREACH) {
      setSignUpType(TYPE_OUTREACH, true).then(this.navigateInitialRoute);
    }
  };

  setType = type => {
    const { setSignUpType } = this.props;
    setSignUpType(type, true).then(this.navigateNext);
  };

  setInviteType = () => {
    const { inviteData, setSignUpType } = this.props;
    switch (inviteData.invitation_type) {
      case 'OUTREACH': {
        setSignUpType(TYPE_OUTREACH).then(this.navigateInitialRoute);
        break;
      }
      case FRIEND: {
        setSignUpType(TYPE_CONTACT_INVITE).then(this.navigateInitialRoute);
        break;
      }
      case BUSINESS: {
        const signupType = TYPE_CONTACT_INVITE;
        setSignUpType(signupType).then(this.navigateInitialRoute);
        break;
      }
      case HOUSEHOLD: {
        // check for project invite
        const signupType = false ? TYPE_PROJECT_INVITE : TYPE_HOUSEHOLD_INVITE;
        setSignUpType(signupType).then(this.navigateInitialRoute);
        break;
      }
      case 'HOMEOWNER_REFERRAL': {
        setSignUpType(TYPE_HOMEOWNER_REFERRAL_INVITE).then(
          this.navigateInitialRoute,
        );
        break;
      }
      default: {
        setSignUpType(TYPE_GENERIC_INVITE).then(this.navigateInitialRoute);
        break;
      }
    }
  };

  navigateInitialRoute = () => {
    const { type, history, authenticated, inviteData, location } = this.props;
    if (type === TYPE_OUTREACH) {
      history.replace(INFO);
    } else if (
      authenticated &&
      inviteData.invitation_type !== TYPE_DOOR_KNOCKING
    ) {
      history.replace(CONFIRM);
    } else if (
      type === TYPE_CONTACT_INVITE &&
      !inviteData.community_invite &&
      !inviteData.invitation_type === BUSINESS
    ) {
      history.replace(INFO);
    } else {
      if (location.state) {
        history.replace({ pathname: INSTRUCTIONS, state: location.state });
      } else {
        history.replace(INSTRUCTIONS);
      }
    }
    this.setState({
      loading: false,
    });
  };

  navigateNextOriginal = (nextStatus = {}, currentConfig) => {
    const {
      history,
      route,
      type,
      authSignUpComplete,
      propertyData,
      userData,
      inviteData,
    } = this.props;

    let config = currentConfig || configs[route];
    if (!config) {
      config = configs[SELECT];
    }

    let nextRoute;
    const nextSuccess = get(config, `onSuccess.${type}`);
    const nextError = get(config, `onError.${type}`);

    if (nextStatus.success && nextSuccess) {
      nextRoute = nextSuccess;
    } else if (nextStatus.error && nextError) {
      nextRoute = nextError;
    } else {
      if (config.nextConfig) {
        nextRoute = config.nextConfig[type];
      }

      if (!nextRoute) {
        nextRoute = config.next;
      }
    }

    if (configs[nextRoute]) {
      if (configs[nextRoute].ngRoute) {
        const streetDeal = get(inviteData, 'street_deal');
        const property = get(inviteData, 'related_property');
        authSignUpComplete().then(() => {
          let redirectRoute = configs[nextRoute].ngRoute;
          if (streetDeal) {
            // generate street deal deeplink url
            redirectRoute = `${
              configs['/streetdeal/'].ngRoute
            }?street_deal_id=${streetDeal.id}${
              get(streetDeal, 'product_sku_id')
                ? `&product_sku_id=${get(streetDeal, 'product_sku_id')}`
                : ''
            }${`&merchant_id=${streetDeal.business_id}`}#sidenav=user_rewards_${
              userData.id
            }`;
          }
          ngRedirect(redirectRoute, {
            propertyData: { ...propertyData, ...property },
            userData,
          });
        });
        return Promise.resolve();
      }
    }

    const onNext = get(config, `onNext.${type}`);

    if (onNext) {
      onNext();
    }

    if (nextRoute === USER_PHOTO) {
      this.openTOSModal();
    } else if (nextRoute === '/') {
      authSignUpComplete().then(() => {
        delay(() => {
          window.location = `${constants.BASE_URL}`;
        }, 100);
      });
    } else if (config.replace) {
      history.replace(nextRoute);
    } else if (get(this.props, 'location.state')) {
      history.push({ pathname: nextRoute, state: this.props.location.state });
    } else {
      history.push(nextRoute);
    }

    return Promise.resolve();
  };

  openTOSModal = () => {
    this.setState({
      TOSModalOpen: true,
    });
  };

  render() {
    const {
      type,
      location,
      status,
      inviteData,
      networkErrorData,
      authNetworkError,
      userData,
    } = this.props;
    const { loading, TOSModalOpen } = this.state;

    // instructions page has value props component that needs more room than 600 allows
    const isInstructions = location.pathname === '/signup/instructions';
    const isInfoform = location.pathname === '/signup/info';
    const frameWidth = isInstructions ? 850 : isInfoform ? '100%' : 600;

    return (
      <SignupContainer
        style={{ width: frameWidth, ...(isInfoform && { boxShadow: 'none' }) }}
      >
        <NetworkErrorModal
          showNetworkError={get(networkErrorData, 'showNetworkError', false)}
          networkErrorMessage={get(networkErrorData, 'networkErrorMessage', '')}
          closeNetworkModal={() =>
            authNetworkError({
              showNetworkError: false,
              networkErrorMessage: '',
            })
          }
        />
        <TOSModal
          isOpen={TOSModalOpen}
          closeModal={() => this.setState({ TOSModalOpen: false })}
          userData={userData}
          navigateNext={this.navigateNext}
        />
        <div className={styles.container}>
          <div
            style={{
              flexDirection: 'column',
              display: 'flex',
              width: '100%',
              minHeight: 30,
            }}
          >
            {loading || status === API_STATUS.SUCCESS_LOADING ? (
              <div
                style={{
                  minHeight: 400,
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <Loader />
              </div>
            ) : (
              <>
                <RedirectHelper openTOSModal={this.openTOSModal} />
                {inviteData &&
                inviteData.invitation_type === 'HOMEOWNER_REFERRAL' &&
                isInstructions ? (
                  <div />
                ) : (
                  <SignUpBanner location={location} />
                )}
                <Switch>
                  <Route
                    path={routes.SIGNUP}
                    exact
                    render={() => <Redirect to={`${routes.SIGNUP}/select`} />}
                  />
                  <Route
                    path={OUTREACH}
                    render={props => (
                      <InfoForm
                        // @todo - force remount when devTools state changes, might be a more elegant way around this
                        key={JSON.stringify(this.props.devTools)}
                        {...props}
                        navigateNext={this.navigateNext}
                      />
                    )}
                  />
                  <Route
                    path={INFO}
                    render={props =>
                      type === TYPE_GENERIC_BUSINESS ? (
                        <InfoFormBusiness
                          {...props}
                          isBusiness
                          navigateNext={this.navigateNext}
                        />
                      ) : (
                        <InfoForm
                          // @todo - force remount when devTools state changes, might be a more elegant way around this
                          key={JSON.stringify(this.props.devTools)}
                          {...props}
                          navigateNext={this.navigateNext}
                        />
                      )
                    }
                  />
                  <Route
                    path={CONFIRM}
                    render={props => (
                      <Confirm {...props} navigateNext={this.navigateNext} />
                    )}
                  />
                  <Route
                    path={HOUSEHOLD_SELECT}
                    render={props => (
                      <HouseholdSelect
                        {...props}
                        navigateNext={this.navigateNext}
                      />
                    )}
                  />
                  <Route
                    path={HOUSEHOLD_REQUEST}
                    render={props => (
                      <HouseholdRequest
                        {...props}
                        navigateNext={this.navigateNext}
                      />
                    )}
                  />
                  <Route
                    path={INSTRUCTIONS}
                    render={props => (
                      <Instructions
                        {...props}
                        type={type}
                        inviteData={inviteData}
                        navigateNext={this.navigateNext}
                      />
                    )}
                  />
                  <Route
                    path={PROPERTY_PHOTO}
                    render={props => (
                      <PropertyPhoto
                        {...props}
                        navigateNext={this.navigateNext}
                      />
                    )}
                  />
                  <Route
                    path={PROPERTY_SELECT}
                    render={props => (
                      <PropertySelect
                        {...props}
                        navigateNext={this.navigateNext}
                      />
                    )}
                  />
                  <Route
                    path={PROPERTY_RETRY}
                    render={props => (
                      <PropertyRetry
                        {...props}
                        navigateNext={this.navigateNext}
                      />
                    )}
                  />
                  <Route
                    path={HOUSEHOLD_CONFIRM}
                    render={props => (
                      <Confirm
                        {...props}
                        type="REQUEST"
                        navigateNext={this.navigateNext}
                      />
                    )}
                  />
                  <Route
                    path={SELECT}
                    render={props => (
                      <Select
                        {...props}
                        selectType={USER}
                        setType={this.setType}
                      />
                    )}
                  />
                  <Route
                    path={SIGNIN}
                    render={props => (
                      <SignIn {...props} navigateNext={this.navigateNext} />
                    )}
                  />
                  <Route
                    path={BUSINESS_SELECT}
                    render={props => (
                      <Select {...props} selectType={BUSINESS} />
                    )}
                  />
                  <Route
                    path={USER_PHOTO}
                    render={props => (
                      <UserPhoto
                        {...props}
                        navigateNext={this.navigateNext}
                        openTOSModal={this.openTOSModal}
                      />
                    )}
                  />
                  <Route
                    path={INVALID_INVITATION}
                    render={props => (
                      <ExpiredInvitation
                        {...props}
                        navigateNext={this.navigateNext}
                      />
                    )}
                  />
                  <Route
                    path="*"
                    render={props => (
                      <Redirect to={`${routes.SIGNUP}/select`} />
                    )}
                  />
                </Switch>
              </>
            )}
          </div>
        </div>
      </SignupContainer>
    );
  }
}

const mapStateToProps = state => ({
  type: selectSignUpType(state),
  route: selectSignUpRoute(state),
  inviteData: selectSignUpInvite(state),
  propertyData: selectSignUpProperty(state),
  userData: selectSignUpUser(state),
  authenticated: selectAuthenticated(state),
  status: state.auth.status,
  networkErrorData: selectNetworkError(state),
  devTools: state.devTools || null,
});

const bindAction = {
  authLogin: actionAuthLogin,
  getAuthInvite: actionGetAuthInvite,
  setSignUpType: actionSetSignUpType,
  setSignUpRoute: actionSetSignUpRoute,
  authSignUpComplete: actionAuthSignUpComplete,
  authNetworkError: actionShowNetworkError,
};

export default withRouter(
  connect(
    mapStateToProps,
    bindAction,
  )(SignUpRouter),
);
